var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserprofile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5635",
    "data-name": "Rectangle 5635",
    width: 21,
    height: 21,
    transform: "translate(-5986 -17367)",
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_de_masques_174",
    "data-name": "Groupe de masques 174",
    transform: "translate(5986 17367)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-user-alt",
    "data-name": "Icon awesome-user-alt",
    d: "M9.948,11.191a5.6,5.6,0,1,0-5.6-5.6A5.6,5.6,0,0,0,9.948,11.191Zm4.974,1.243H12.781a6.764,6.764,0,0,1-5.666,0H4.974A4.974,4.974,0,0,0,0,17.409v.622A1.866,1.866,0,0,0,1.865,19.9H18.03A1.866,1.866,0,0,0,19.9,18.03v-.622A4.974,4.974,0,0,0,14.922,12.435Z",
    transform: "translate(-5985 -17366)",
    fill: "#f06649"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserprofile);
export default __webpack_public_path__ + "static/media/user profile.c9136249108ef2d33b5fbafda7824273.svg";
export { ForwardRef as ReactComponent };